import { Grid } from '@mui/material';
import React from 'react';
import { MandateGeneralDto } from '../../../services/dtos/mandate-general.dto';
import { MandateEstablishmentDto } from '../../../services/dtos/mandate-establishment-dto';
import { MandateTerritoryDto } from '../../../services/dtos/mandate-territory.dto';
import DocumentsUi from '../documents/documents.ui';
import { useLocation } from 'react-router-dom';

export default function DecisionDeliberationUi(
    props: Readonly<{
        mandate: MandateGeneralDto | MandateEstablishmentDto | MandateTerritoryDto;
    }>
) {
    const location = useLocation();

    let title = '';
    switch (location.pathname) {
        case '/elu/ag':
            title = "l'assemblée générale";
            break;
        case '/elu/bsca':
            title = "bureau Syndical et Conseil d'Administration";
            break;
        case '/elu/territoire':
            title = 'territoire';
            break;
        case '/elu/assainissement':
        case '/elu/eau':
            title = 'COPE';
            break;
        case '/elu/bassin':
            title = 'bassin';
            break;
    }

    return (
        <Grid container className={'decison-deliberation-ui'} rowSpacing={1}>
            <Grid item xs={12}>
                <DocumentsUi
                    mandate={props.mandate}
                    fixedType={'decision'}
                    title={`Décisions de ${title}`}
                    hideTypeFilter
                />
            </Grid>
            <Grid item xs={12}>
                <DocumentsUi
                    mandate={props.mandate}
                    fixedType={'deliberation'}
                    title={`Délibérations prises par le Conseil d'Administration en application des décisions de ${title}`}
                    hideTypeFilter
                />
            </Grid>
        </Grid>
    );
}
